import styled from 'styled-components';

export const GovAnchor = styled.a`
  color: #000;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  max-width: 560px;
`;
